import { BrowserClient } from '@sentry/browser';
import { getConfigFor } from './getConfigFor';
import { defaultClientName } from '.';

const clientMap = new Map<string, BrowserClient>();

export const getClientFor = (
  name: string = defaultClientName,
): BrowserClient => {
  if (clientMap.has(name)) {
    return clientMap.get(name)!;
  }

  const client = new BrowserClient(getConfigFor(name));
  clientMap.set(name, client);

  return client;
};
